import { toDateValue } from "./datetime";

const formatUtcDateForCalendar = (date) => {
  const pad = (value) => `${value}`.padStart(2, "0");

  return [
    `${date.getUTCFullYear()}`,
    pad(date.getUTCMonth() + 1),
    pad(date.getUTCDate()),
    "T",
    pad(date.getUTCHours()),
    pad(date.getUTCMinutes()),
    pad(date.getUTCSeconds()),
    "Z",
  ].join("");
};

const escapeIcsText = (value) =>
  value
    .replace(/\\/g, "\\\\")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;")
    .replace(/\n/g, "\\n");

const getLabRange = (lab) => {
  const start = toDateValue(lab.dateTime);

  if (!start) {
    throw new Error("Cannot create calendar links without a valid lab dateTime.");
  }

  const duration = Number(lab.durationMinutes || 60);
  const end = new Date(start.getTime() + duration * 60 * 1000);

  return { start, end };
};

const buildIcsContent = (lab, start, end) => {
  const eventDescription = `Join the AI Lab for School Leaders. Zoom: ${lab.zoomLink || "TBD"}`;
  const eventLocation = lab.zoomLink || "Online";
  const uid = `${lab.id || "ai-lab"}-${start.getTime()}@gruvyeducation.com`;

  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Gruvy Education//AI Lab for School Leaders//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${formatUtcDateForCalendar(new Date())}`,
    `DTSTART:${formatUtcDateForCalendar(start)}`,
    `DTEND:${formatUtcDateForCalendar(end)}`,
    `SUMMARY:${escapeIcsText(lab.title || "AI Lab for School Leaders")}`,
    `DESCRIPTION:${escapeIcsText(eventDescription)}`,
    `LOCATION:${escapeIcsText(eventLocation)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
};

export const buildCalendarLinks = (lab) => {
  const { start, end } = getLabRange(lab);
  const details = `Join the AI Lab for School Leaders. Zoom link: ${lab.zoomLink || "TBD"}`;
  const location = lab.zoomLink || "Online";

  const googleParams = new URLSearchParams({
    action: "TEMPLATE",
    text: lab.title || "AI Lab for School Leaders",
    dates: `${formatUtcDateForCalendar(start)}/${formatUtcDateForCalendar(end)}`,
    details,
    location,
  });

  const outlookParams = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: lab.title || "AI Lab for School Leaders",
    startdt: start.toISOString(),
    enddt: end.toISOString(),
    body: details,
    location,
  });

  const icsContent = buildIcsContent(lab, start, end);

  return {
    googleUrl: `https://calendar.google.com/calendar/render?${googleParams.toString()}`,
    outlookUrl: `https://outlook.office.com/calendar/0/deeplink/compose?${outlookParams.toString()}`,
    icsDataUrl: `data:text/calendar;charset=utf-8,${encodeURIComponent(icsContent)}`,
    icsContent,
  };
};

export const downloadIcsFile = (lab) => {
  const { icsContent } = buildCalendarLinks(lab);
  const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const safeId = (lab.id || "ai-lab").replace(/[^a-z0-9-_]/gi, "").toLowerCase();

  link.href = url;
  link.download = `${safeId || "ai-lab"}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
